import { Country } from '@prisma/client';
import * as z from 'zod';

export const businessDetailsSchema = z.object({
  businessDescription: z.string().trim().min(25, {
    message: 'Please enter a description with at least 25 characters.',
  }),
  businessActivity: z
    .array(z.string())
    .max(5, { message: 'Upto 5 business activities allowed.' }),
  estimatedAnnualTurnover: z
    .number()
    .min(0, { message: 'Turnover should be greater than 0.' }),
  exportCountries: z
    .array(
      z.nativeEnum(Country, {
        errorMap: () => ({ message: 'Please select countries.' }),
      })
    )
    .max(5, { message: 'Upto 5 countries allowed.' }),
  importCountries: z
    .array(
      z.nativeEnum(Country, {
        errorMap: () => ({ message: 'Please select countries.' }),
      })
    )
    .max(5, { message: 'Upto 5 countries allowed.' }),
});

export type TBusinessDetailsFields = z.infer<typeof businessDetailsSchema>;
